import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import { Box, Button, Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import { useState, type FC, type PropsWithChildren } from "react";
import loginPageImg from "../../../images/login_page.png";
import logoImg from "../../../images/logo-przezmorze.svg";

import B2bOption from "./B2bOption";
import B2bRequestDialog from "./B2bRequestDialog";
import { useNewSeasonComponent } from "./useNewSeasonComponent";
interface Props {
  readonly minWidth?: string;
}

const AnnouncmentCard = ({ children }: PropsWithChildren) => (
  <Card
    sx={{
      background: "rgba(255, 255, 255, 0.1)",
      backdropFilter: "blur(10px)",
      border: "1px solid rgba(255, 255, 255, 0.2)",
      borderRadius: 4,
      color: "white",
      boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.3)",
    }}
  >
    {children}
  </Card>
);

const Announcments = () => {
  const { data: newSeasonComponent } = useNewSeasonComponent();

  return (
    <Stack spacing={3} sx={{ maxWidth: 420, zIndex: 2 }}>
      {/* Nowa karta: Travel360 Prezentacja */}
      <AnnouncmentCard>
        <CardContent sx={{ p: 3 }}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              fontWeight: "bold",
            }}
          >
            <TravelExploreIcon />
            Odkryj Travel360
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.9, mb: 2 }}>
            B2B.PrzezMorze to tylko jeden z elementów całego ekosystemu Travel360. Dowiedz się, jak nasza platforma może
            zautomatyzować Twoje biuro podróży.
          </Typography>
          <Button
            variant="contained"
            fullWidth
            sx={{
              "&:hover": { bgcolor: "primary.dark" },
              borderRadius: 2,
              bgcolor: "#3557a1",
              textTransform: "none",
              fontWeight: "bold",
            }}
          >
            Umów się na bezpłatną prezentację
          </Button>
        </CardContent>
      </AnnouncmentCard>

      {/* Istniejąca karta: Nowy sezon */}
      {newSeasonComponent && (
        <AnnouncmentCard>
          <CardContent sx={{ p: 3 }}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                fontWeight: "bold",
              }}
            >
              Nowy sezon 2026!
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.9, mb: 2 }}>
              Odkryj naszą nową ofertę wycieczek szkolnych i grupowych. Zaloguj się, aby uzyskać dostęp do specjalnych
              cen i materiałów B2B.
            </Typography>
            <Button
              variant="contained"
              sx={{
                bgcolor: "rgba(255,255,255,0.2)",
                color: "white",
                backdropFilter: "blur(4px)",
                "&:hover": { bgcolor: "rgba(255,255,255,0.3)" },
                borderRadius: 2,
                textTransform: "none",
              }}
            >
              Sprawdź nowości
            </Button>
          </CardContent>
        </AnnouncmentCard>
      )}
    </Stack>
  );
};

const SignInSignUpContainer: FC<PropsWithChildren<Props>> = ({ children }) => {
  const [openRequestDialog, setOpenRequestDialog] = useState(false);

  return (
    <>
      <Grid container sx={{ minHeight: "100vh", m: 0, p: 0 }}>
        <Grid
          size={{ xs: 12, md: 7, lg: 8 }}
          sx={{
            position: "relative",
            backgroundImage: `url(${loginPageImg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: { xs: "none", md: "flex" },
            flexDirection: "column",
            justifyContent: "flex-end",
            p: 6,
          }}
        >
          <Announcments />
        </Grid>
        <Grid
          size={{ xs: 12, md: 5, lg: 4 }}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            px: { xs: 4, sm: 8, md: 6, lg: 8 },
            py: 8,
            bgcolor: "background.paper",
            boxShadow: { md: "-10px 0px 30px rgba(0,0,0,0.05)" },
            zIndex: 1,
          }}
        >
          <Box
            component="img"
            src={logoImg}
            alt="Przezmorze.pl"
            sx={{
              display: "block",
              maxWidth: "100%",
              maxHeight: 48,
              height: "auto",
              width: "auto",
              mb: 6,
              alignSelf: "flex-start",
            }}
          />
          {children}
          <B2bOption setOpenRequestDialog={setOpenRequestDialog} />
        </Grid>
      </Grid>
      <B2bRequestDialog openRequestDialog={openRequestDialog} setOpenRequestDialog={setOpenRequestDialog} />
    </>
  );
};

export default SignInSignUpContainer;
